import { render, staticRenderFns } from "./SelectListSection.vue?vue&type=template&id=5a0875c8&scoped=true"
import script from "./SelectListSection.vue?vue&type=script&lang=ts"
export * from "./SelectListSection.vue?vue&type=script&lang=ts"
import style0 from "./SelectListSection.vue?vue&type=style&index=0&id=5a0875c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0875c8",
  null
  
)

export default component.exports